"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultLoginState = void 0;
exports.defaultLoginState = {
    isActive: false,
    isDim: false,
    isLoading: false,
    facebookAppId: '195795017684541',
    loginFields: {
        email: '',
        password: '',
        rememberMe: false,
    },
    t: {
        nameTitle: 'Login',
        nameCaption: 'Tailor-made experience with MyOkay.com',
        nameOr: 'or',
        nameFacebook: 'Facebook',
        nameNoAccount: 'Don\'t have an account',
        nameRegister: 'Sign Up',
        nameCancel: 'Cancel',
    },
    tForm: {
        email: 'Email',
        password: 'Password',
        rememberMe: 'Keep Login',
        forgetPassword: 'Forget Password?',
        submit: 'Submit',
        emailFormat: 'Invalid Email Format',
        required: 'Required',
    },
};
